import { render, staticRenderFns } from "./DadosMedicos.vue?vue&type=template&id=5804bbf8&"
import script from "./DadosMedicos.vue?vue&type=script&lang=js&"
export * from "./DadosMedicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports